<template>
  <DataVisCard :is-loading="loading">
    <template #download-dropdown-options>
      <slot name="download-options-slot">
        <li>
          <a
            href="#"
            @click="
              $refs.chart.downloadImage(`${$t(title)}-${DateRange.start}-${DateRange.end}.png`)
            "
          >
            PNG
          </a>
        </li>
        <li>
          <a
            href="#"
            @click="$refs.chart.downloadCsv(`${$t(title)}-${DateRange.start}-${DateRange.end}.csv`)"
          >
            CSV
          </a>
        </li>
      </slot>
    </template>
    <template #head>
      <slot name="header">
        <DataVisHeader
          v-model:date-range="DateRange"
          :title="title"
          :filters="localActiveFilters"
          @remove-filter="$emit('remove-filter', $event)"
        >
          <slot name="tag" />
        </DataVisHeader>
      </slot>
    </template>
    <template #help>
      <slot name="help-slot" />
    </template>
    <template #dropdown>
      <slot name="dropdown">
        <DataVisDropdown
          v-model:chart-type="chart"
          :show-grid="grid"
          :multiple-datasets="dataSeries.dataSets.length > 1"
          icon="zmdi-eye"
          @toggle-grid="grid = !grid"
        >
          <slot name="LocalFilter" />
        </DataVisDropdown>
      </slot>
    </template>
    <template #body>
      <slot name="graph">
        <DataVisChart
          ref="chart"
          :loading="loading"
          :data-object="dataSeries"
          :show-grid="grid"
          :chart-type="chart"
          :unit="unit"
        />
      </slot>
    </template>
  </DataVisCard>
</template>

<script>
import DataVisCard from '@/components/DataVisCard.vue'
import DataVisChart from '@/components/DataVisChart.vue'
import DataVisHeader from '@/components/DataVisHeader.vue'
import DataVisDropdown from '@/components/DataVisDropdown.vue'
import { PropChartType } from '@/mixins/PropChartType'
import { StatisticSeries } from '@/vue-prop-types/Statistics'
import DateRange from '@/vue-prop-types/DateRange'

export default {
  name: 'DataVisGraph',
  components: {
    DataVisDropdown,
    DataVisHeader,
    DataVisCard,
    DataVisChart,
  },
  mixins: [PropChartType],
  props: {
    // chartType // From mixin
    title: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    showGrid: {
      type: Boolean,
      default: false,
    },
    localActiveFilters: {
      type: Array,
      default: () => [],
    },
    // If given a localDateRange it will overwrite the global one as the visual one
    localDateRange: {
      type: DateRange,
      default: null,
    },
    unit: {
      type: String,
      default: 'currency',
    },
    dataSeries: {
      type: StatisticSeries,
      default() {
        return new StatisticSeries()
      },
    },
  },
  data() {
    return {
      grid: null,
      chart: null,
      dateRange: new DateRange(),
    }
  },
  computed: {
    DateRange: {
      get() {
        return this.localDateRange || this.dateRange
      },
      set(range) {
        // eslint-disable-next-line vue/no-mutating-props -- Baseline eslint ignore please fix if working on this
        this.localDateRange = range
        this.$emit('updated-date-range', range)
      },
    },
  },
  created() {
    this.grid = this.showGrid
    this.chart = this.chartType
  },
}
</script>

<style scoped></style>
